import { format } from 'date-fns';
import React from 'react';
import { prepDate } from './helpers';

export const HumanReadableDate: React.FC<{ validFrom: Date | string | null; validTo: Date | string | null }> = ({
    validFrom,
    validTo,
}) => {
    if (validFrom && validTo) {
        return (
            <>
                Gültig von <time>{format(prepDate(validFrom), 'dd.MM.yyyy')}</time> bis zum{' '}
                <time>{format(prepDate(validTo), 'dd.MM.yyyy')}</time>
            </>
        );
    } else if (validFrom && !validTo) {
        return (
            <>
                Gültig ab <time>{format(prepDate(validFrom), 'dd.MM.yyyy')}</time>
            </>
        );
    } else if (!validFrom && validTo) {
        return (
            <>
                Gültig bis <time>{format(prepDate(validTo), 'dd.MM.yyyy')}</time>
            </>
        );
    } else {
        return <></>;
    }
};
